export default __webpack_public_path__ + "static/media/vhhp2021_about.fedbb86a.png";